import { DataAccessContext } from '@axo/shared/data-access/provider';
import { permissions } from '@axo/shared/data-access/types';
import { useContext, useMemo } from 'react';

export const aceRoles: permissions.RoleName[] = [
  permissions.RoleName.Manager,
  permissions.RoleName.Sales,
  permissions.RoleName.SecuredSales,
  permissions.RoleName.Telemarketing,
  permissions.RoleName.TelemarketingLimited,
];

export function useAvailableMarketCountries() {
  const {
    state: {
      user: { roles },
    },
  } = useContext(DataAccessContext);
  return useMemo(
    () =>
      roles
        ?.filter(({ Name }) => aceRoles.includes(Name as permissions.RoleName))
        .map(({ Country }) => Country)
        .filter((country): country is string => !!country),
    [roles],
  );
}
